/* eslint-disable react/no-multi-comp, react/display-name */
import React from "react";
export default class PromoPriceVariantHelper {
  static shouldSeePromoPrice = experimentVariant =>
    (window.experimentVariants && window.experimentVariants.includes("item_level_promo_var_a")) ||
      experimentVariant === "item_level_promo_var_a"

  static shouldSeePromoPriceAndDiscount = experimentVariant =>
    (window.experimentVariants && window.experimentVariants.includes("item_level_promo_var_b")) ||
      experimentVariant === "item_level_promo_var_b"

  static renderPromoPriceOnGrid = (price, promoPrice) =>
    <div className="price flex justify-center align-middle gap-2 py-0.5">
      <span className="strike">
        {price}
      </span>
      <span className="font-bold text-tangerine-100">
        {promoPrice}
      </span>
    </div>

  static renderPromoPriceAndDiscountOnGrid = (price, promoPrice, discountText) =>
    <div className="price flex justify-center align-middle gap-2 py-0.5">
      <span className="strike">
        {price}
      </span>
      <span className="font-bold text-tangerine-100">
        {promoPrice}
      </span>
      <span className="bg-tangerine-100 text-white font-bold px-1 rounded-md">
        {discountText}
      </span>
    </div>

  static renderPromoPriceOnProductPage = (price, promoPrice) =>
    <div className="styled_h5 flex gap-2 py-0.5">
      <span className="strike">
        {price}
      </span>
      <span className="font-bold text-tangerine-100">
        {promoPrice}
      </span>
    </div>

  static renderPromoPriceAndDiscountOnProductPage = (price, promoPrice, discountText) =>
    <div className="styled_h5 flex gap-2 py-0.5">
      <span className="strike">
        {price}
      </span>
      <span className="font-bold text-tangerine-100">
        {promoPrice}
      </span>
      <span className="bg-tangerine-100 text-white font-bold px-1 rounded-md">
        {discountText}
      </span>
    </div>
}
